import type {HsvSockets} from "#material/nodes/color/hsv/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<HsvSockets>
type Previous = Omit<Current, "settings"> & {settings: MaterialNodeSettings<HsvSockets> & {disabled?: boolean}}

/** Muting a node is ui.disabled, which every renderer reads and the exchange format carries as internal.mute. */
export const dropDisabledNoRendererReads: Version<Previous, Current> = {
    toNextVersion: ({settings: {disabled, ...settings} = {}, ...parameters}) => ({...parameters, settings}),
}
